export const STATE_NAME = 'alertSystem';
export const ALERT = 'ALERT';
export const CLOSE = 'ALERT_CLOSE';
